import React, { useState } from 'react';
import {
  Divider,
  IconButton,
  List,
  SwipeableDrawer,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  Menu,
  Inbox,
  Calendar,
  CheckSquare,
  LogOut,
  User,
  HelpCircle,
  Gift,
  ThumbsUp,
  Video,
  ShoppingCart,
} from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { usePublicConfig } from '@pv/common/providers';
import { apiHost } from '@pv/common/api';
import { HamburgerMenuItem } from '@pv/core/src/components/HamburgerMenuItem';
import { ConfettiIcon } from '../../../icons';
import { usePermissions } from '../../../../hooks/usePermissions';

const API_HOST = apiHost(process.env.REACT_APP_PV_ENV);

const HamburgerMenu = () => {
  const theme = useTheme();
  const { publicConfig } = usePublicConfig();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { canViewInbox } = usePermissions();

  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const navAndClose = (path) => () => {
    navigate(path);
    onClose();
  };

  const openLinkAndCloseDrawer = (path) => () => {
    window.open(path);
    setOpen(false);
  };

  const pagesList = [
    {
      icon: <ConfettiIcon style={{ color: theme.palette.primary.main }} />,
      text: 'Events',
      onClick: navAndClose('/events'),
    },
    {
      icon: <ShoppingCart style={{ color: theme.palette.primary.main }} />,
      text: 'Express Book',
      onClick: navAndClose('/express_book'),
    },
    {
      icon: <Inbox style={{ color: theme.palette.primary.main }} />,
      text: 'Inbox',
      onClick: navAndClose('/inbox'),
      hidden: !canViewInbox,
    },
    {
      icon: <Calendar style={{ color: theme.palette.primary.main }} />,
      text: 'Calendar',
      onClick: navAndClose('/calendar'),
    },
    {
      icon: <CheckSquare style={{ color: theme.palette.primary.main }} />,
      text: 'Tasks',
      onClick: navAndClose('/tasks'),
    },
  ];

  const helpList = [
    {
      icon: <Video style={{ color: theme.palette.primary.main }} />,
      text: 'Training Video',
      onClick: openLinkAndCloseDrawer(
        'https://help.perfectvenue.com/knowledge/training-video-for-venues'
      ),
    },
    {
      icon: <ThumbsUp style={{ color: theme.palette.primary.main }} />,
      text: 'Feedback',
      onClick: openLinkAndCloseDrawer(
        'https://perfectvenue.canny.io/feature-requests'
      ),
    },
    {
      icon: <Gift style={{ color: theme.palette.primary.main }} />,
      text: 'Refer a Friend',
      onClick: openLinkAndCloseDrawer('https://form.typeform.com/to/vNu4kAfJ'),
    },
    {
      icon: <HelpCircle style={{ color: theme.palette.primary.main }} />,
      text: 'Help Center',
      onClick: openLinkAndCloseDrawer(
        'https://help.perfectvenue.com/knowledge'
      ),
    },
  ];

  const settingsList = [
    ...(smallScreen
      ? [
          {
            icon: <User style={{ color: theme.palette.primary.main }} />,
            text: 'Profile',
            onClick: navAndClose('/settings/profile'),
          },
        ]
      : []),
    {
      icon: <LogOut style={{ color: theme.palette.primary.main }} />,
      text: 'Logout',
      onClick: () => {
        window.location.href = `${API_HOST}${publicConfig.paths.destroyUserSession}`;
      },
    },
  ];

  return (
    <>
      <IconButton onClick={onOpen}>
        <Menu style={{ color: 'white' }} />
      </IconButton>
      <SwipeableDrawer
        anchor="left"
        open={open}
        onClose={onClose}
        onOpen={onOpen}
      >
        <div>
          <List component="nav" style={{ width: '250px' }}>
            {pagesList
              .filter((p) => !p.hidden)
              .map(({ icon, text, onClick }) => (
                <HamburgerMenuItem
                  key={text}
                  icon={icon}
                  text={text}
                  onClick={onClick}
                />
              ))}

            <Divider />
            {helpList.map(({ icon, text, onClick }) => (
              <HamburgerMenuItem
                key={text}
                icon={icon}
                text={text}
                onClick={onClick}
              />
            ))}
            <Divider />
            {settingsList.map(({ icon, text, onClick }) => (
              <HamburgerMenuItem
                key={text}
                icon={icon}
                text={text}
                onClick={onClick}
              />
            ))}
          </List>
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default HamburgerMenu;
